import React, { Fragment, useState } from 'react';
import PrintIcon from '@material-ui/icons/Print';
import LaunchIcon from '@material-ui/icons/Launch';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';

const ReactTableActions = ({ data, refresh, Callback }) => {

    return (<Fragment>
        <td role="cell">

            <Tooltip title="Editar">
                <IconButton aria-label="edit" onClick={() => {                   
                    Callback(data.data.original);
                }}>
                    <EditOutlinedIcon />
                </IconButton>
            </Tooltip>
           
        </td>
    </Fragment>)
}

export default ReactTableActions;